// Available locations
export const locations = [
  { id: 1, name: "Downtown San Francisco" },
  { id: 2, name: "Menlo Park" },
  { id: 3, name: "Berkeley" },
];

// Available physicians
export const physicians = [
  { id: 1, name: "Dr. Sarah Johnson", specialty: "Family Medicine" },
  { id: 2, name: "Dr. Michael Chen", specialty: "Internal Medicine" },
  { id: 3, name: "Dr. Emily Rodriguez", specialty: "Pediatrics" },
];

// Generate available time slots for the next 7 days
const generateTimeSlots = () => {
  const slots = [];
  const today = new Date();

  // For each of the next 7 days
  for (let day = 0; day < 7; day++) {
    const currentDate = new Date(today);
    currentDate.setDate(today.getDate() + day);

    // Skip weekends
    if (currentDate.getDay() === 0 || currentDate.getDay() === 6) continue;

    // Generate slots from 8 AM to 5 PM
    for (let hour = 8; hour < 17; hour++) {
      // 15-minute intervals
      for (let minute = 0; minute < 60; minute += 15) {
        // Randomly assign availability (70% chance of being available)
        const isAvailable = Math.random() < 0.7;
        if (isAvailable) {
          const startTime = new Date(currentDate);
          startTime.setHours(hour, minute, 0, 0);

          const endTime = new Date(startTime);
          endTime.setMinutes(endTime.getMinutes() + 15);

          // Randomly assign a physician and location
          const physicianId =
            physicians[Math.floor(Math.random() * physicians.length)].id;
          const locationId =
            locations[Math.floor(Math.random() * locations.length)].id;

          slots.push({
            id: `slot-${day}-${hour}-${minute}`,
            startTime: startTime.toISOString(),
            endTime: endTime.toISOString(),
            physicianId,
            locationId,
            isBooked: false,
          });
        }
      }
    }
  }
  return slots;
};

export const availableSlots = generateTimeSlots();

// User's booked appointments
export const myAppointments = [
  {
    id: "appt-1",
    startTime: new Date(
      new Date().setDate(new Date().getDate() + 1)
    ).toISOString(),
    endTime: new Date(
      new Date().setDate(new Date().getDate() + 1)
    ).toISOString(),
    physicianId: 1,
    locationId: 2,
    status: "confirmed",
  },
  {
    id: "appt-2",
    startTime: new Date(
      new Date().setDate(new Date().getDate() + 3)
    ).toISOString(),
    endTime: new Date(
      new Date().setDate(new Date().getDate() + 3)
    ).toISOString(),
    physicianId: 3,
    locationId: 1,
    status: "confirmed",
  },
];
